import partners from "@/wl-core/db/partners";

export default {
    partners:partners
}
